import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faCalendar, faCalendarDay, faCalendarWeek } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { AutocompleteOption, ListItemDecorator } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../../../design/inputs/select/Select';
import { TimePeriod } from '../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';

interface IProps {
  selectedTimePeriod: TimePeriod;
  onPeriodChange: (period: TimePeriod) => Promise<void>;
}

export const StatisticsTimeFrameSwitch = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { onPeriodChange, selectedTimePeriod } = props;

  const options = [
    { value: TimePeriod.All, icon: faCalendar, label: t('teams.filter.all') },
    { value: TimePeriod.Day, icon: faCalendarDay, label: t('teams.filter.today') },
    { value: TimePeriod.Week, icon: faCalendarWeek, label: t('teams.filter.week') },
    { value: TimePeriod.Month, icon: faCalendarAlt, label: t('teams.filter.month') },
  ];

  return (
    <Select
      value={options.find((x) => x.value === selectedTimePeriod)}
      onChange={(_, v) => {
        void onPeriodChange(v.value ?? TimePeriod.All);
      }}
      options={options}
      renderOption={(props, option) => (
        <AutocompleteOption {...props}>
          <ListItemDecorator>
            <FontAwesomeIcon icon={option.icon} />
          </ListItemDecorator>
          {option.label}
        </AutocompleteOption>
      )}
    />
  );
});
